/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_PURCHASE_SUCCESS,
  LOAD_PURCHASE_ERROR,
  LOAD_RECORDS_VALID_CACHE,
  LOAD_PURCHASE_RECORDS_META_DATA_SUCCESS,
  LOAD_PURCHASE_RECORDS_META_DATA_ERROR,
  CREATE_PURCHASE_SUCCESS,
  CREATE_PURCHASE_ERROR,
  UPDATE_PURCHASE_SUCCESS,
  UPDATE_PURCHASE_ERROR,
  DELETE_PURCHASE_SUCCESS,
  DELETE_PURCHASE_ERROR,
  LOAD_PURCHASE_PARTIES_CATEGORY_SUCCESS,
  LOAD_PURCHASE_PARTIES_CATEGORY_ERROR,
  CREATE_PURCHASE_PARTIES_CATEGORY_SUCCESS,
  CREATE_PURCHASE_PARTIES_CATEGORY_ERROR,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_PARTIES_TRANSACTION_ERROR,
  LOAD_PARTY_VENDOR_ADDRESS_SUCCESS,
  LOAD_PARTY_VENDOR_ADDRESS_ERROR,
  CREATE_PARTY_VENDOR_ADDRESS_SUCCESS,
  CREATE_PARTY_VENDOR_ADDRESS_ERROR,
  LOAD_DASHBOARD_TRANSACTION_SUCCESS,
  LOAD_DASHBOARD_TRANSACTION_ERROR,
  LOAD_TOTAL_BALANCE_SUCCESS,
  LOAD_TOTAL_BALANCE_ERROR,
} from "./constants";

const initialState = {
  parties_list: [],
  dashboard_transactions: [],
  total_balance_list: [],
  parties_collect_list: [],
  parties_pay_list: [],
  category_list: [],
  party_address_list: [],
  parties_transaction_list: [],
  record: {},
  records: {},
  recordsMetaData: {},
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    parties_list,
    dashboard_transactions,
    total_balance_list,
    party_address_list,
    category_list,
    parties_transaction_list,
    record,
    recordsMetaData = {},
    error,
    success,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_SUCCESS:
        draft.parties_list = parties_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_DASHBOARD_TRANSACTION_SUCCESS:
        draft.dashboard_transactions = dashboard_transactions;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_TOTAL_BALANCE_SUCCESS:
        draft.total_balance_list = total_balance_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PARTY_VENDOR_ADDRESS_SUCCESS:
        draft.party_address_list = party_address_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_PURCHASE_PARTIES_CATEGORY_SUCCESS:
        draft.category_list = category_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_PURCHASE_PARTIES_CATEGORY_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case LOAD_PARTIES_TRANSACTION_SUCCESS:
        draft.parties_transaction_list = parties_transaction_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_PURCHASE_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case CREATE_PARTY_VENDOR_ADDRESS_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case UPDATE_PURCHASE_SUCCESS:
        draft.record = [record].concat(state.record);
        draft.error = false;
        draft.success = success;
        break;
      case DELETE_PURCHASE_SUCCESS:
        draft.record = record;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_PURCHASE_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_PURCHASE_ERROR:
      case LOAD_PURCHASE_PARTIES_CATEGORY_ERROR:
      case LOAD_PARTY_VENDOR_ADDRESS_ERROR:
      case CREATE_PURCHASE_PARTIES_CATEGORY_ERROR:
      case CREATE_PARTY_VENDOR_ADDRESS_ERROR:
      case LOAD_PARTIES_TRANSACTION_ERROR:
      case LOAD_DASHBOARD_TRANSACTION_ERROR:
      case LOAD_TOTAL_BALANCE_ERROR:
      case CREATE_PURCHASE_ERROR:
      case UPDATE_PURCHASE_ERROR:
      case DELETE_PURCHASE_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      case LOAD_PURCHASE_RECORDS_META_DATA_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
